import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenDocLineXtnDocLineMatchingBalanceContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/erp/gen-doc/generic-doc-line-xtn-doc-line-matching-balances/backoffice-ep

@Injectable({ providedIn: "root" })
export class GenDocLineXtnDocLinMatchingBalanceService extends BaseApiTemplateService<GenDocLineXtnDocLineMatchingBalanceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX + "generic-doc-line-xtn-doc-line-matching-balances/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX + "generic-doc-line-xtn-doc-line-matching-balances/backoffice-ep";
    this.httpClient = http;
  }
}
